import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/suppliers")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/suppliers", statusCode: 301 });
  },
});
